module.exports = __webpack_public_path__ + "static/the-complete-stories-7c3afd281a62cfb81b838df3aadd28ce.jpg";